@if (link(); as target) {
  <a
    class="activity-entry"
    [routerLink]="target"
    [attr.aria-label]="'liveDashboard.activity.openAria' | translate: { title: item().title }"
  >
    <ng-container [ngTemplateOutlet]="body" />
  </a>
} @else {
  <div class="activity-entry">
    <ng-container [ngTemplateOutlet]="body" />
  </div>
}

<ng-template #body>
  <span class="activity-entry__avatar" [style.background]="tint()" [style.color]="color()" aria-hidden="true">
    <mat-icon>{{ visual().icon }}</mat-icon>
  </span>
  <span class="activity-entry__main">
    <span class="activity-entry__title">{{ item().title }}</span>
    <span class="activity-entry__sub">
      {{ item().subtitle }}
      @if (item().badge) {
        <span class="activity-entry__sep" aria-hidden="true"></span>
        <span class="activity-entry__badge">{{ item().badge }}</span>
      }
    </span>
  </span>
  <span class="activity-entry__time" [title]="item().timestamp | date: 'medium'">
    {{ item().timestamp | relativeTime: locale() }}
  </span>
</ng-template>
